import EmailTemplateBase from '../shared/emailtemplate-base';

export default class EmailTemplate extends EmailTemplateBase {
    constructor(...args) {
        super(...args);
    }
}



// WEBPACK FOOTER //
// ./src/template/emailtemplate-model.js